import { render, staticRenderFns } from "./update-region.vue?vue&type=template&id=4ade7cb9"
import script from "./update-region.vue?vue&type=script&lang=js"
export * from "./update-region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports